<template>
  <li class="tree-view-node">
    <div class="node-line">
      <div class="expand-box">
        <i class="fa fa-chevron-down collapse-button" v-if="nodeData.children&&nodeData.children.length" @click="toggleCollapse(nodeData)" :class="{'collapse-button-collapse':isCollapse}"></i>
      </div>
      <span class="node-line-title" :class="{'node-active':helpData.activeItem.id===nodeData.id}" @click="operate('click', nodeData)" href="javascript:;">
        {{ nodeData.name }}
      </span>
      <i class="operate-btn" v-if="nodeData.operations && op !== 'click'" v-for="op of nodeData.operations" :key="op" :class="[ 'fa', `fa-${mapOperationClass(op)}` ]" @click="operate(op, nodeData)"></i>
    </div>
    <ul v-if="nodeData.children&&nodeData.children.length&&!isCollapse" class="child-node-box">
      <TreeViewItem :nodeData="item" v-for="item in nodeData.children" :key="item.id" :helpData="helpData" @operate="operate" @toggleCollapse="toggleCollapse" />
    </ul>
  </li>
</template>
<script>
export default {
  name: 'TreeViewItem',
  props: {
    nodeData: {
      type: Object,
      required: true
    },
    helpData: {
      type: Object,
      required: true
    }
  },
  methods: {
    operate (operation, value) {
      this.$emit('operate', operation, value)
    },
    toggleCollapse (item) {
      this.$emit('toggleCollapse', item)
    },
    mapOperationClass (operation) {
      let map = {
        add: 'plus',
        edit: 'edit',
        remove: 'remove',
        copy: 'copy',
        export: 'upload',
        import: 'download'
      }
      return map[operation]
    }
  },
  computed: {
    isCollapse () {
      return !!this.helpData.collapseMap[this.nodeData.id]
    }
  }
}
</script>

<style>
.tree-view,
.tree-view ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.tree-view-node .node-line {
  margin: 1px 0;
  display: flex;
  align-items: center;
}
.node-line .node-line-title {
  padding: 5px 10px;
  flex: 1;
  cursor: pointer;
  color: #007bff;
  border-radius: 4px;
}
.node-line .node-line-title:hover {
  background: #cbe0ff;
}

.tree-view-node .expand-box {
  width: 20px;
}
.tree-view-node .collapse-button {
  transition: all 0.3s;
  width: 16px;
  height: 16px;
}
.tree-view-node i {
  cursor: pointer;
  color: #007bff;
  float: right;
}
.tree-view-node .operate-btn {
  margin: 0 3px;
}
.tree-view-node i:hover {
  color: #0a3c71;
}
.tree-view-node .collapse-button-collapse {
  transform: rotateZ(-90deg);
}
.tree-view-node .node-active {
  background-color: #cbe0ff;
}
.tree-view-node .child-node-box{
  padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/utils/tree-view-item.vue